/**
 * Generator function which yields all integers between a and b.
 *
 * @param {number} a - Lower bound
 * @param {number} b - Upper bound
 */
export function* intsBetween(a, b) {
    const bFloor = Math.floor(b);
    for (let floor = Math.floor(a) + 1; floor <= bFloor; floor++) {
        yield floor;
    }
}
